import { fetchWithHeaders, parseResponse } from '../shared/utils'

export function fetchPage(id, locale) {
  return fetchWithHeaders(`/v1/resources?name=${id}&locale=${locale}`, {
    method: 'GET',
  })
    .then(parseResponse)
    .then(res => res.data)
}
